import { DeviceLocation as DeviceLocationModel } from '@rocksoft/mdm-sdk-v2';

import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

export interface DeviceLocation extends DeviceLocationModel {
  udid: string;
}

export type DeviceLocationState = EntityState<DeviceLocation>;

export function selectId(deviceLocation: DeviceLocation) {
  return deviceLocation.udid;
}

export const adapter: EntityAdapter<DeviceLocation> = createEntityAdapter<DeviceLocation>({
  selectId,
});

export const initialState: DeviceLocationState = adapter.getInitialState();
